import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

//models
import { signUpModel } from '../../models/signup/signup.model';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html'
})
export class signupComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public signUpModel : signUpModel = new signUpModel;
  public allUserData : any = [];
  public registeredUserData : any = null;
  public CreateUserResponseData : any = null;
  public otpSend : boolean = false;
  public sendOtpResponeData : any = "";
  public validateOtpResponeData : any = "";
  public serviceOn : boolean = false;
  
 
  constructor(public http: HttpTestService, public session: sessionServices) { }

  ngOnInit() {
	  this.getSession();
	 
}
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
		
	}
	
	cancelReg = function(){
		var self = this;
		self.registeredUserData = null;
		self.signUpModel.consumerMobile = "";
		self.signUpModel.consumerEmail = "";
		self.signUpModel.consumerPass = "";
		self.signUpModel.consumerId = "";
		self.otpSend = false;
		self.signUpModel.consumerOtp = "";
	}
	
	sendOTP = function(){
		var self = this;
		self.serviceOn = true;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.signUpModel.consumerId;
		self.http.sendOTP(requestedConsumer+"^"+self.signUpModel.consumerMobile)
		  .subscribe(
			(data) => {
			  self.sendOtpResponeData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.sendOtpResponeData = "";
			},
			() => {
				
				
				if(self.sendOtpResponeData){
					self.otpSend = true;
				}
				self.serviceOn = false;
			}
	);
	}
	
	validateOTP = function(){
		var self = this;
		self.serviceOn = true;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.signUpModel.consumerId;
		var requestedOtp = self.signUpModel.consumerOtp;
	
	
		self.http.validateOTP(requestedConsumer+"^"+requestedOtp)
		  .subscribe(
			(data) => {
			  self.validateOtpResponeData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.validateOtpResponeData = "";
			},
			() => {
				
				
				if(self.validateOtpResponeData){
					self.createUser();
				}else{
					self.errorMsg = "OTP mismatched. Please enter the right OTP.";
					self.serviceOn = false;
				}
				
			}
	);
		
	}
	
	//get consumer details
	getConsumerDetails = function(e){
		var self = this;
		self.serviceOn = true;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		self.signUpModel.consumerOtp = "";
		var requestedConsumer = self.signUpModel.consumerId;
		
		self.http.getUserDetailsByConsNo(requestedConsumer)
		  .subscribe(
			(data) => {
				self.allUserData = data;
				
			  },
			(error) => {
				self.errorMsg = error;
				self.allUserData = "";
			},
			() => {
				
				if (self.allUserData.status === "GAYACONSUMERID") {
					self.errorMsg = "Service is not available for this number range";
					self.allUserData = "";
				} else if(self.allUserData.name){
					self.registeredUserData = self.allUserData;
					
					self.signUpModel.consumerMobile = self.allUserData.mobile;
					self.signUpModel.consumerEmail = self.allUserData.emailid;
				}else{
					self.registeredUserData = "";
				}
				self.serviceOn = false;
			}
	);
	}
	

	createUser = function(){
		var self = this;
		self.serviceOn = true;
		self.errorMsg = "";
		self.successMsg = "";
		self.registeredUserData.mobile = self.signUpModel.consumerMobile;
		self.registeredUserData.mobileNo = self.signUpModel.consumerMobile;
		self.registeredUserData.emailid = self.signUpModel.consumerEmail;
		self.registeredUserData.password = self.signUpModel.consumerPass;
		
		self.http.createUser(self.registeredUserData)
			 .subscribe(
			 (data:any) => {
				 self.CreateUserResponseData = data;
				 if(self.CreateUserResponseData.status === null){
					 self.cancelReg();
					 self.successMsg = "Consumer Id "+self.CreateUserResponseData.consumerNo+" successfully registered.";
					 self.serviceOn = false;
				 }	
				 else{
					self.cancelReg();
					self.errorMsg = self.CreateUserResponseData.status;
					self.serviceOn = false;
				 }
				 },
			 (error) => {
				 self.errorMsg = "Some error occured";
				 self.serviceOn = false;
			 },
			 () => {
				 self.serviceOn = false;	
			 });
		 }
 
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/signup/signup.component.ts